var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextField from '@mui/material/TextField';
import EditableInputWrapperV2 from '../../../components/EditableInputWrapperV2';
import LabelWrapper from '../LabelWrapper';
var TextInput = function (_a) {
    var _b;
    var disabled = _a.disabled, required = _a.required, label = _a.label, className = _a.className, editable = _a.editable, displayValue = _a.displayValue, rest = __rest(_a, ["disabled", "required", "label", "className", "editable", "displayValue"]);
    return (React.createElement(LabelWrapper, { label: label, disabled: disabled, required: required },
        React.createElement(EditableInputWrapperV2, { editable: editable, value: displayValue === null || displayValue === void 0 ? void 0 : displayValue((_b = rest.InputProps) === null || _b === void 0 ? void 0 : _b.value) },
            React.createElement(TextField, __assign({ className: "lfc-w-full ".concat(className), size: "small" }, rest, { disabled: disabled, label: undefined, inputProps: __assign({ onWheel: function (event) {
                        event.currentTarget.blur();
                    } }, rest.inputProps) })))));
};
export default TextInput;
//# sourceMappingURL=TextInput.js.map